export default "__VITE_ASSET__B8j_Z9LX__"